import {
  SENDING_REQUEST,
  REQUEST_ERROR,
  SHOW_PROGRESS_BAR,
  HIDE_PROGRESS_BAR,
  CHANGE_BUSINESS_TYPES_DATA,
  CHANGE_BUSINESS_CATEGORIES_ALL_DATA,
  CHANGE_BUSINESS_STARTS_DATA,
  CHANGE_BUSINESS_SALES_DATA,
  CHANGE_FORM_REGISTER,
  CHANGE_FORM_RESET_PASSWORD,
  SET_RESEND_VERIFICATION_EMAIL_STATE,
  SHOW_LOADING_SPINNER,
} from './types';

export function showLoadingSpinner(showLoadingSpinner) {
  return { type: SHOW_LOADING_SPINNER, payload: { showLoadingSpinner } };
}

/**
 * Sets the `currentlySending` state, which displays a loading indicator during requests
 * @param  {boolean} sending True means we're sending a request, false means we're not
 */
export function sendingRequest(sending) {
  return { type: SENDING_REQUEST, payload: { sending } };
}

/**
 * Sets the `error` state to the error received
 * @param  {object} error The error we got when trying to make the request
 */
export function requestError(error) {
  return { type: REQUEST_ERROR, payload: { error } };
}

/**
 * Show the progress bar
 * @returns {{type, payload: {}}}
 */
export function showProgressBar() {
  return { type: SHOW_PROGRESS_BAR };
}

export function hideProgressBar() {
  return { type: HIDE_PROGRESS_BAR };
}

export function changeBusinessTypesData(newBusinessTypes) {
  return { type: CHANGE_BUSINESS_TYPES_DATA, payload: { newBusinessTypes } };
}

export function changeBusinessCategoriesAllData(newBusinessCategoriesAll) {
  return {
    type: CHANGE_BUSINESS_CATEGORIES_ALL_DATA,
    payload: { newBusinessCategoriesAll },
  };
}

export function changeBusinessStartsData(newBusinessStarts) {
  return { type: CHANGE_BUSINESS_STARTS_DATA, payload: { newBusinessStarts } };
}

export function changeBusinessSalesData(newBusinessSales) {
  return { type: CHANGE_BUSINESS_SALES_DATA, payload: { newBusinessSales } };
}

/**
 * Sets the form state
 * @param  {object} newFormRegState          The new state of the form
 * @param  {string} newFormRegState.email The new text of the email input field of the form
 * @param  {string} newFormRegState.password The new text of the password input field of the form
 * @param  {string} newFormRegState.confpassword The new text of the confirm password input field of the form
 */
export function changeFormRegister(newFormRegState) {
  return { type: CHANGE_FORM_REGISTER, payload: { newFormRegState } };
}

export function changeFormResetPassword(data) {
  return {
    type: CHANGE_FORM_RESET_PASSWORD,
    payload: { resetPasswordState: data },
  };
}

export function setResendEmailVerificationState(data) {
  return {
    type: SET_RESEND_VERIFICATION_EMAIL_STATE,
    payload: {
      resendVerificationEmail: {
        isModalShow: data.isModalShow,
        headerMessage: data.headerMessage,
        bodyMessage: data.bodyMessage,
        modalStatus: data.modalStatus,
      },
    },
  };
}
